import React, { useState } from "react";
import Ham from "../assets/hamburger.svg";
import Close from "../assets/close.svg";
import VisibilitySensor from "react-visibility-sensor";
import { Spring } from "react-spring/renderprops";

const Header = () => {
  const [active, setActive] = useState(false);

  return (
    <div className="w-full fontR">
      <div className="hidden lg:block w-full px-10 py-5 ">
        <div className="flex justify-around items-center item">
          <h3 className="dark-blue text-4xl font-bold">
            F’<span className="light-blue">A</span>
          </h3>
          <div className="flex justify-evenly w-2/4  mr-56 ">
            <a href="#CaseStudy">
              <p className="nav-link cursor-pointer text-2xl ">Experience</p>
            </a>
            <a href="#Stack">
              <p className="nav-link cursor-pointer text-2xl">Stack</p>
            </a>
            <a href="#Contact">
              <p className="nav-link cursor-pointer text-2xl">Contact</p>
            </a>
          </div>
        </div>
      </div>
      <div className="lg:hidden w-full p-5  flex justify-between items-center fixed top-0 z-30 bg-white">
        <h3 className="dark-blue text-2xl font-bold">
          F’<span className="light-blue">A</span>
        </h3>
        <img
          src={!active ? Ham : Close}
          alt="hamburger-menu"
          className="w-7 h-7"
          onClick={() => setActive(!active)}
        />
      </div>
      {active ? (
        <VisibilitySensor partialVisibility>
          {({ isVisible }) => (
            <Spring
              delay={100}
              to={{
                height: isVisible ? "200px" : "0px",
                zIndex: "10",
                transform: isVisible ? "translateX(0)" : "translateX(20%)",
              }}
            >
              {(props) => (
                <div
                  className="fixed w-full z-30 px-5  py-4 bg-white top-14 self-right"
                  style={{ ...props, backgroundColor: "#FFFFFF" }}
                >
                  <ul>
                    <li className="nav-link cursor-pointer py-4 text-xl">
                      <a href="#CaseStudy">Experience </a>
                    </li>

                    <li className="nav-link cursor-pointer py-4 text-xl">
                      <a href="#Stack">Stack </a>
                    </li>
                    <li className="nav-link cursor-pointer py-4 text-xl">
                      <a href="#Contact">Contacts</a>
                    </li>
                  </ul>
                </div>
              )}
            </Spring>
          )}
        </VisibilitySensor>
      ) : (
        <></>
      )}
    </div>
  );
};

export default Header;
